import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { useMemo } from 'react';
import { useControlGroupContext } from '../ControlGroup';
import { useFlex } from '../Flex';
import * as styles from './BaseField.styles';
/**
 * @typedef OwnProps
 * @property {boolean} [error=false] Renders an error.
 * @property {boolean} [disabled] Whether the field is disabled.
 * @property {boolean} [isClickable=false] Renders a `cursor: pointer` on hover.
 * @property {boolean} [isFocused=false] Renders focus styles.
 * @property {boolean} [isInline=false] Renders as an inline element (layout).
 * @property {boolean} [isSubtle=false] Renders a subtle variant.
 */

/** @typedef {import('../Flex/useFlex').FlexProps & OwnProps} Props */

/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'div'>} props
 */

export function useBaseField(props) {
  var _useContextSystem = useContextSystem(props, 'BaseField'),
      className = _useContextSystem.className,
      defaultValue = _useContextSystem.defaultValue,
      _useContextSystem$err = _useContextSystem.error,
      error = _useContextSystem$err === void 0 ? false : _useContextSystem$err,
      _useContextSystem$isC = _useContextSystem.isClickable,
      isClickable = _useContextSystem$isC === void 0 ? false : _useContextSystem$isC,
      _useContextSystem$isF = _useContextSystem.isFocused,
      isFocused = _useContextSystem$isF === void 0 ? false : _useContextSystem$isF,
      _useContextSystem$isI = _useContextSystem.isInline,
      isInline = _useContextSystem$isI === void 0 ? false : _useContextSystem$isI,
      _useContextSystem$isS = _useContextSystem.isSubtle,
      isSubtle = _useContextSystem$isS === void 0 ? false : _useContextSystem$isS,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "defaultValue", "error", "isClickable", "isFocused", "isInline", "isSubtle"]);

  var _useControlGroupConte = useControlGroupContext(),
      controlGroupStyles = _useControlGroupConte.styles;

  var classes = useMemo(function () {
    return cx(styles.BaseField, controlGroupStyles, isClickable && styles.clickable, isFocused && styles.focus, isSubtle && styles.subtle, error && styles.error, error && isFocused && styles.errorFocus, isInline && styles.inline, className);
  }, [className, controlGroupStyles, error, isInline, isClickable, isFocused, isSubtle]);
  var flexProps = useFlex(_objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  }));
  return flexProps;
}